import React from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { dropdownVariants, reducedVariants } from '../../motion/tokens';
import usePrefersReducedMotion from '../../motion/usePrefersReducedMotion';

export default function DropdownPanel({
  open,
  children,
  className = '',
  style,
  transformOrigin = 'top right',
  ...rest
}) {
  const reduced = usePrefersReducedMotion();
  const variants = reducedVariants(dropdownVariants, reduced);

  return (
    <AnimatePresence>
      {open ? (
        <motion.div
          className={className}
          style={{ transformOrigin, ...style }}
          variants={variants}
          initial="hidden"
          animate="visible"
          exit="exit"
          {...rest}
        >
          {children}
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
